<template>
  <div class="content-gridless-login container mt-5" style="max-width: 500px">
    <div class="card bg-light">
      <div class="card-body">
        <form class="login" @submit.prevent="login">
          <div class="d-flex justify-content-center">
            <h1>Login</h1>
          </div>
          
          <div class="form-group">
            <label for="usernameInput" v-bind:class="{ 'text-danger': error }">
              User name
            </label>
            <input
              id="usernameInput"
              class="form-control"
              required
              v-model="username"
              v-bind:class="{ 'is-invalid': error }"
              type="text"
              placeholder="User name"
            />
            <small id="userNameHelp" class="form-text text-danger" v-if="error">
              {{ error_msg }}
            </small>
          </div>
          <div class="form-group" >
            <label for="passwordInput" v-bind:class="{ 'text-danger': error }">
              Password
            </label>
            <input
              id="passwordInput"
              class="form-control"
              required
              v-model="password"
              v-bind:class="{ 'is-invalid': error }"
              type="password"
              placeholder="Password"
            />
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary" type="submit">Login</button>
          </div>
          
        </form>
      </div>
    </div>
    
 </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      error: false,
      error_msg: "Ungültige Zugangsdaten",
    };
  },
  methods: {
    login: function() {
      const { username, password } = this;
      this.$store.dispatch("login", { username, password }).then(() => {
        this.error = false;
        window.location.href = "/";
      }).catch((err) => {
        if (err.request) {
          if (err.request.status == 401) {
            this.error_msg = "Ungültige Zugangsdaten"
          } else if (!err.response) {
            this.error_msg = "Netzwerkfehler"
          }
        } else {
          this.error_msg = "Netzwerkfehler"
        }
        // eslint-disable-next-line
        console.log(err.message)
        this.error = true;
      });
    }
  }
};
</script>

<style scoped>
</style>

